import { Component, OnInit, ViewChild, ElementRef, ContentChild } from '@angular/core';
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbModal, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';
import { saveAs as importedSaveAs } from "file-saver";

import { ServiceService } from 'src/app/services/service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SortingModel, SortingCurrentStatus } from './sortingModel';
const Stomp = require('stompjs');
import * as SockJs from 'sockjs-client';
import { NgbCustomDateParserService } from 'src/app/formatters/ngb-custom-date-parser.service';
import { UserService } from 'src/app/services/user.service';


declare const JSZip: any;
declare const saveAs: any;

@Component({
  selector: 'app-paper-work',
  templateUrl: './paper-work.component.html',
  styleUrls: ['./paper-work.component.css', './progress-bar.css']
})
export class PaperWorkComponent implements OnInit {
  @ViewChild('openModal') errorModal: ElementRef<HTMLElement>;

  showProgressBar = false;
  noOfRecord: number = 1000;
  private stompClient: any = null;
  whoOwnsItsData: any = {};
  user: any;
  timer: any;
  allowedTenants: any[] = [];
  allowedCustomers: any[] = [];
  billOfLaddingResponse: any = null;
  singleBillOfLaddingDetails = null;

  availableBatchNumbers = [];
  availableBolImageSent = [];

  terminals = [];
  suppliers = [];
  dealers = [];
  public selectedSupplier = null;
  public selectedTerminal = null;

  /**Filter params. */
  public selectedDealer = null;
  public orderNoFilter = null;
  public carrierFilter = null;
  public terminalFilter = null;
  public supplierFilter = null;
  public dealerFilter = null;
  public bolStatusFilter = null;
  public notesFilter = null;
  public tacFilter = null;
  public billtypeFilter = null;
  public invoiceFilter = null;
  public filterQuery = null;
  public bolstatusMap = new Map();

  public showInvoices: boolean = false;
  public hideOrShow: boolean = false;

  hoveredDate: NgbDate;

  fromDate: NgbDate;
  toDate: NgbDate;

  modalRef: any;
  selectedItem: any;
  selectedRouteSheet = {};

  allPageTotals: any;
  totalRegQuantity: any;
  totalMidQuantity: any;
  totalSupQuantity: any;
  totalUlsdQuantity: any;
  totalOthQuantity: any;
  httpRequestllowedTenants = [];
  screenHeight = screen.height - (35 / 100 * screen.height);
  link: any = "";
  errorMsg = "";
  successMsg = "";
  error: boolean = false;
  sortingModels: SortingModel[] = [];
  sortingCurrentStatus: SortingCurrentStatus = new SortingCurrentStatus();
  billofladingNotes = null;
  availalableBatchNumbersTenantMap = [];
  availalableBolImageSentFilesTenantMap = [];

  invoicesList = [];
  bolImagesList = [];
  selectedInvoicesList = [];
  selectedBolImagesList = [];


  public size = 50;
  public page = 1;
  public clearCache = true;
  public role: any = null;
  public httpRequest: any = null;
  public shouldDisplayLiteNavigator = false;
  showOverlay = false;
  userScac = "";
  public canUploadFiles = false;
  public bolImages = [];

  fileNames = [];
  bolFileNames = [];
  allowBolEditFromPortal = false;
  billofladingidHub = null

  dealerFilterConfig = {
    displayKey: 'dealer', //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    height: '309px', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
    placeholder: 'Filter Dealer', // text to be displayed when no item is selected defaults to Select,
    customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
    limitTo: 100, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
    searchPlaceholder: 'Search Dealer', // label thats displayed in search input,
    searchOnKey: 'dealer', // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  }

  terminalFilterConfig = {
    displayKey: 'terminalName', //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    height: '309px', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
    placeholder: 'Terminal', // text to be displayed when no item is selected defaults to Select,
    customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
    limitTo: 100, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
    searchPlaceholder: 'Search Terminal', // label thats displayed in search input,
    searchOnKey: 'terminalName', // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  }

  supplierFilterConfig = {
    displayKey: 'loadUnderName', //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    height: '309px', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
    placeholder: 'Supplier', // text to be displayed when no item is selected defaults to Select,
    customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
    limitTo: 100, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
    searchPlaceholder: 'Search Supplier', // label thats displayed in search input,
    searchOnKey: 'loadUnderName', // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  }


  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter,
    private route: ActivatedRoute,
    private router: Router,
    private ngModal: NgbModal,
    private datePipe: DatePipe,
    private service: ServiceService,
    public ngbCustomDateParserService: NgbCustomDateParserService,
    public userService: UserService) {

    this.user = JSON.parse(localStorage.getItem("user"));
    this.showInvoices = this.user.user.showInvoices;
    this.role = this.user.user.role.role;
    this.canUploadFiles = this.user.user.canUploadDashboardFiles;
    for (var ctr = 0; ctr < 10; ctr++) {
      this.bolstatusMap.set(ctr + '', "Order Received");
    }

    const tenantscac = localStorage.getItem("user_scac");
    if (tenantscac == "jomr") {
      this.shouldDisplayLiteNavigator = true;
    }

    // this.bolstatusMap.set("1", "Order Received");
    this.bolstatusMap.set("10", "Dispatched");
    this.bolstatusMap.set("12", "Enroute to Rack");
    this.bolstatusMap.set("20", "At Rack");
    this.bolstatusMap.set("22", "Left Rack");
    this.bolstatusMap.set("24", "At Location");
    this.bolstatusMap.set("26", "Finished");

    for (var ctr = 26; ctr < 50; ctr++) {
      this.bolstatusMap.set(ctr + '', "Finished");
    }

    this.fromDate = calendar.getPrev(calendar.getToday(), 'd', 1);
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 0);
    this.getUserSpec();
    this.getBillOfLaddings(false);
    // this.connectWebSocket();
    this.userService.allowBolEdit().subscribe((user: any) => {
      this.allowBolEditFromPortal = user?.allowBolEditFromPortal;
    })
  }

  ngOnInit() {
    console.log("Timer", this.timer)
    this.userScac = localStorage.getItem("user_scac");
  }

  ngOnDestroy() {
    console.log("destory called");
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  public getBillOfLaddings(csvExport?: boolean, count?): void {
    console.log("getBillOfLaddings");
    if (!this.toDate) {
      this.toDate = this.calendar.getNext(this.fromDate, 'd', 0);
    }
    const fromDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
    const toDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
    const from_date = this.datePipe.transform(fromDate, 'yyyy-MM-dd');
    const to_date = this.datePipe.transform(toDate, 'yyyy-MM-dd');
    let requestUrl = null;

    this.generateBackendFilters();

    $(".overlay-loading").show();
    let url = 'get-bol-details/v2?size=' + this.noOfRecord + '&page=0';


    if (this.role && this.role != "ROLE_FTP_IMPORT") {
      requestUrl = this.service.getBillOfladdings(
        url, from_date, to_date, this.filterQuery, this.orderNoFilter, this.carrierFilter,
        this.terminalFilter,
        this.supplierFilter,
        this.dealerFilter,
        this.bolStatusFilter,
        this.notesFilter,
        csvExport,
        null,
        this.sortingModels,
        this.tacFilter,
        this.invoiceFilter,
        this.billtypeFilter
      );
    } else {
      requestUrl = this.service.getFTPRelatedBillofladings(this.size,
        this.page - 1,
        from_date, to_date,
        this.carrierFilter,
        this.supplierFilter,
        this.terminalFilter,
        this.bolStatusFilter,
        this.clearCache,
        this.notesFilter,
        this.orderNoFilter,
        csvExport,
        this.dealerFilter,
        null,
        this.billtypeFilter
      );
    }


    requestUrl.subscribe(data => {
      if (csvExport) {
        var mediaType = "text/csv";
        var blob = new Blob([data], { type: mediaType });

        var filename = 'BOL-' + from_date.substr(0, 10) + '-' + to_date.substr(0, 10) + '.csv';
        importedSaveAs(blob, filename);
      } else {
        this.billOfLaddingResponse = data;
        this.allPageTotals = data.totalQuantity;
        this.totalRegQuantity = data.totalRegQuantity;
        this.totalMidQuantity = data.totalMidQuantity;
        this.totalSupQuantity = data.totalSupQuantity;
        this.totalUlsdQuantity = data.totalUlsdQuantity;
        this.totalOthQuantity = data.totalOthQuantity;
        // this.dealers = data.dealers;
        this.fetchDealerFilters(true);
        this.fetchDownloadableFiles();
      }
      $(".overlay-loading").hide();
    }, error => {
      console.log(error);
      $(".overlay-loading").hide();
      if (!count) {
        count = 0;
      }
      if (count < 3) {
        this.getBillOfLaddings(csvExport, count++);
      }
    });

  }

  private fetchDownloadableFiles() {

    this.availalableBatchNumbersTenantMap = [];
    this.availalableBolImageSentFilesTenantMap = [];
    this.fileNames = [];
    this.bolFileNames = [];
    this.invoicesList = [];
    this.bolImagesList = [];

    this.billOfLaddingResponse.billofladings.map(billoflading => billoflading?.batchNumber && this.fileNames.push(billoflading?.batchNumber + "::" + billoflading?.tenant));
    this.billOfLaddingResponse.billofladings.map(billoflading => billoflading?.bolimageSent && this.bolFileNames.push(billoflading?.billOfLadingId + "::" + billoflading?.tenant));
    this.service.listFilesFromS3InvoiceFolder(this.fileNames, this.bolFileNames, this.userScac, ".pdf").subscribe(success => {
      this.availableBatchNumbers = success?.invoiceFiles;
      this.availableBolImageSent = success?.bolFiles;

      this.billOfLaddingResponse?.billofladings.forEach(billoflading => {
        billoflading?.bolimageSent && this.availalableBolImageSentFilesTenantMap.push(billoflading?.billOfLadingId + "::" + billoflading?.tenant);
        billoflading?.batchNumber && this.availalableBatchNumbersTenantMap.push(billoflading?.batchNumber + "::" + billoflading?.tenant);
      });

      console.log("availalableBatchNumbersTenantMap", this.availalableBatchNumbersTenantMap);
      console.log("availalableBolImageSentFilesTenantMap", this.availalableBolImageSentFilesTenantMap);

      if (this.availalableBatchNumbersTenantMap && this.availalableBatchNumbersTenantMap.length > 0) {
        this.invoicesList = [];
        $(".overlay-loading").show();
        this.service.listFilesUrlFromS3(this.availalableBatchNumbersTenantMap, "Invoices", this.userScac).subscribe(success => {
          $(".overlay-loading").hide();
          console.log("::Success", success);
          this.invoicesList = Object.entries(success).map(([key, value]) => ({ key, value }));
          console.log("this.invoicesList", this.invoicesList);
        }, error => {
          $(".overlay-loading").hide();
          console.error("Error occurred in invoices::", error);
        });
      }

      if (this.availalableBolImageSentFilesTenantMap && this.availalableBolImageSentFilesTenantMap.length > 0) {
        this.bolImagesList = [];

        $(".overlay-loading").show();
        
        this.service.listFilesUrlFromS3(this.availalableBolImageSentFilesTenantMap, "Images", this.userScac).subscribe(success => {
          $(".overlay-loading").hide();
          console.log("::Success", success);
          this.bolImagesList = Object.entries(success).map(([key, value]) => ({ key, value }));
          this.selectedBolImagesList = [...this.bolImagesList];
          console.log("this.bolImagesList", this.bolImagesList);
        }, error => {
          $(".overlay-loading").hide();
          console.error("Error occurred in invoices::", error);
        });
      }

      console.log("::Success", success);
    }, error => {
      console.error("Error occurred in invoices::", error);
    });
  }

  clickToDownloadBolImagesList() {
    this.showProgressBar = true;
    onDownloadClick(this.selectedBolImagesList ? this.selectedBolImagesList : this.bolImagesList, "BOL-Images.zip").then(() => {
      this.showProgressBar = false
      });
  }

  clickToDownloadInvoicesList() {
    this.showProgressBar = true;
    onDownloadClick(this.selectedInvoicesList ? this.selectedInvoicesList : this.invoicesList, "Invoices.zip").then(() => {
      this.showProgressBar = false
    });
  }

  selectAllBolImages() {
    if (this.selectedBolImagesList.length == this.bolImagesList.length) {
      this.selectedBolImagesList = [];
    } else {
      this.selectedBolImagesList = [...this.bolImagesList];
    }
  }

  selectAllInvoices() {
    if (this.selectedInvoicesList.length == this.invoicesList.length) {
      this.selectedInvoicesList = [];
    } else {
      this.selectedInvoicesList = [...this.invoicesList];
    }
  }

  public getBillOfLaddingsWithSorting(csvExport?: boolean): void {
    console.log("getBillOfLaddingsWithSorting");
    const fromDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
    const toDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
    const from_date = this.datePipe.transform(fromDate, 'yyyy-MM-dd');
    const to_date = this.datePipe.transform(toDate, 'yyyy-MM-dd');
    var sortBy: string[] = [];
    var orderBy: string[] = [];

    this.sortingModels.forEach(sortingModel => {
      sortBy.push(sortingModel.fieldName);
      orderBy.push(sortingModel.sortingType);
    })

    // '&page=0&sort-by=tStamp,tenant,billOfLadingId&order-by=desc,desc,asc';
    $(".overlay-loading").show();
    let url = 'get-bol-details/v2?size=' + this.noOfRecord + '&page=0';

    let requestUrl = null;
    if (!this.role || this.role != "ROLE_FTP_IMPORT") {
      let url = 'get-bol-details/v2?size=' + this.size + '&page=' + (this.page ? (this.page - 1) : 0);
      requestUrl = this.service.getBillOfladdings(
        url, from_date, to_date,
        this.filterQuery, this.orderNoFilter, this.carrierFilter,
        this.terminalFilter,
        this.supplierFilter,
        this.dealerFilter,
        this.bolStatusFilter,
        this.notesFilter,
        false,
        null,
        this.sortingModels,
        this.tacFilter,
        this.invoiceFilter,
        this.billtypeFilter
      );
    } else {

      requestUrl = this.service.getFTPRelatedBillofladings(this.size,
        this.page - 1,
        from_date, to_date,
        this.carrierFilter,
        this.supplierFilter,
        this.terminalFilter,
        this.bolStatusFilter,
        this.clearCache,
        this.notesFilter,
        this.orderNoFilter,
        csvExport,
        this.dealerFilter,
        this.filterQuery,
        this.sortingModels,
        this.billtypeFilter
      );
    }

    requestUrl.subscribe(data => {
      if (csvExport) {
        var mediaType = "text/csv";
        var blob = new Blob([data], { type: mediaType });
        var filename = 'BOL-' + from_date.substr(0, 10) + '-' + to_date.substr(0, 10) + '.csv';
        importedSaveAs(blob, filename);
      } else {

        this.billOfLaddingResponse = data;
        this.allPageTotals = data.totalQuantity;
        this.totalRegQuantity = data.totalRegQuantity;
        this.totalMidQuantity = data.totalMidQuantity;
        this.totalSupQuantity = data.totalSupQuantity;
        this.totalUlsdQuantity = data.totalUlsdQuantity;
        this.totalOthQuantity = data.totalOthQuantity;
      }
      $(".overlay-loading").hide();
    }, error => {
      $(".overlay-loading").hide();
    });
  }

  public downloadInvoice(fileName: string, scac: string, fileType?: string, isInvoice?: boolean): void {

    if (isInvoice) {
      $(".overlay-loading").show();
      this.service.downloadInvoice(fileName, fileType, scac).subscribe(res => {
        var mediaType = fileType.indexOf("pdf") > -1 ? 'application/' + fileType : 'image/tiff';

        var blob = new Blob([res], { type: mediaType });
        var filename = fileName + '.' + fileType;
        importedSaveAs(blob, filename);
        $(".overlay-loading").hide();
      }, error => {
        $(".overlay-loading").hide();
        // if (error.indexOf('500 - OK {}') > -1 || error.indexOf('400 - OK {}') > -1 || error.indexOf('504 - OK {}') > -1) {         
        this.service.downloadInvoice(fileName, "tiff", scac).subscribe(res => {
          var mediaType = fileType.indexOf("pdf") > -1 ? 'application/' + fileType : 'image/tiff';

          var blob = new Blob([res], { type: mediaType });
          var filename = fileName + '.' + fileType;
          importedSaveAs(blob, filename);
        });
        // }
      });
    }

  }



  /**
   * 
   * @param fileName - The name of the file
   * @param scac - Scac code of the tenant to which the user belongs
   * @param isInvoice - Is the invoice going to be generated
   */
  public downloadFile(fileName: string, scac: string, isInvoice) {
    $(".overlay-loading").show();

    this.allowedTenants.forEach(tenant => {
      if (tenant.tenantId == scac) {
        scac = tenant.scac;
      }
    });

    this.runSequentialDownload(fileName, scac, isInvoice);
  }

  public downloadCsvPdfFile(fileName: string, scac: string, isInvoice) {
    $(".overlay-loading").show();

    this.allowedTenants.forEach(tenant => {
      if (tenant.tenantId == scac) {
        scac = tenant.scac;
      }
    });

    this.runSequentialDownload(fileName, scac, isInvoice);
  }

  // Tries pdf -> tif -> TIF. Advances to the next format on error OR on a 0-byte
  // response, and reports "No file available" when the final format is also empty.
  private runSequentialDownload(fileName: string, scac: string, isInvoice) {
    const noFileAvailable = () => {
      this.errorMsg = "No file available";
      this.error = true;
      this.errorModal.nativeElement.click();
      $(".overlay-loading").hide();
    };

    const attemptUpperTif = () => {
      const req = !isInvoice ? this.service.downloadFiles(fileName, 'TIF', scac) : this.service.downloadInvoice(fileName, 'TIF', scac);
      req.subscribe(data => {
        const blob = new Blob([data], { type: 'application/tif' });
        if (blob.size === 0) { noFileAvailable(); return; }
        importedSaveAs(blob, fileName + '.TIF');
        this.error = false;
        this.errorMsg = "[ TIF ] File downloaded successfully";
        this.errorModal.nativeElement.click();
        $(".overlay-loading").hide();
      }, error => {
        if (error.status == '500' || error.status == '400') { this.errorMsg = "File Not Found"; }
        else { this.errorMsg = "Error Downloading file"; }
        this.error = true;
        this.errorModal.nativeElement.click();
        $(".overlay-loading").hide();
      });
    };

    const attemptTif = () => {
      const req = !isInvoice ? this.service.downloadFiles(fileName, 'tif', scac) : this.service.downloadInvoice(fileName, 'tif', scac);
      req.subscribe(data => {
        const blob = new Blob([data], { type: 'application/tif' });
        if (blob.size === 0) { attemptUpperTif(); return; }
        importedSaveAs(blob, fileName + '.tif');
        this.error = false;
        this.errorMsg = "[ TIF ] File downloaded successfully";
        this.errorModal.nativeElement.click();
        $(".overlay-loading").hide();
      }, error => { attemptUpperTif(); });
    };

    const req = !isInvoice ? this.service.downloadFiles(fileName, 'pdf', scac) : this.service.downloadInvoice(fileName, 'pdf', scac);
    req.subscribe(data => {
      const blob = new Blob([data], { type: 'application/pdf' });
      if (blob.size === 0) { attemptTif(); return; }
      importedSaveAs(blob, fileName + '.pdf');
      this.error = false;
      this.errorMsg = "[ PDF ] File downloaded successfully";
      this.errorModal.nativeElement.click();
      $(".overlay-loading").hide();
    }, error => {
      $(".overlay-loading").hide();
      if (error?.status == '0' || error?.status == '400' || error?.status == '500'
        || error?.message?.includes("proxy") || error?.message?.includes("Proxy")
        || error?.includes('500 - OK {}') > -1 || error?.includes('400 - OK {}') > -1
        || error?.includes('400') > -1 || error?.includes('504 - OK {}') > -1) {
        attemptTif();
      }
    });
  }



  private getUserSpec(): void {
    this.httpRequestllowedTenants = [];
    $(".overlay-loading").show();
    this.service.getUserDataAccessSpecs().subscribe(data => {
      $(".overlay-loading").hide();
      this.whoOwnsItsData = data;

      // this.terminals = this.whoOwnsItsData.terminals;
      // this.suppliers = this.whoOwnsItsData.suppliers;
      // this.dealers = this.whoOwnsItsData.dealers;

      data.whoOwnsIts.forEach(whoOwnsIt => {
        data.tenantBilltypesMappings.forEach(tenantBilltypesMapping => {
          if (tenantBilltypesMapping.tenant.tenantId == whoOwnsIt.wholesalerTenantID) {
            if (this.httpRequestllowedTenants.indexOf(tenantBilltypesMapping.tenant) == -1) {
              this.httpRequestllowedTenants.push(tenantBilltypesMapping.tenant);
            }
          }
        });
      });

      _.forEach(data.whoOwnsIts, (whoOwnsIt) => {
        let index = _.findIndex(data.tenantBilltypesMappings, (item) => {
          return item.tenant.tenantId == whoOwnsIt.wholesalerTenantID;
        });
        if (index !== -1 && this.httpRequestllowedTenants.indexOf(data.tenantBilltypesMappings[index].tenant) == -1) {
          this.httpRequestllowedTenants.push(data.tenantBilltypesMappings[index].tenant);
        }
      });


      if (null != this.selectedTerminal) {
        this.terminals.forEach(terminal => {
          if (this.selectedTerminal.idHub == terminal.idHub) {
            this.selectedTerminal = terminal;
          }
        });
      }

      if (null != this.selectedDealer) {
        this.dealers.forEach(dealer => {
          if (this.selectedDealer.idHub == dealer.idHub) {
            this.selectedDealer = dealer;
          }
        });
      }

      if (null != this.selectedSupplier) {
        this.suppliers.forEach(supplier => {
          if (this.selectedSupplier?.loadUnderName?.toLowerCase().indexOf(supplier?.loadUnderName?.toLowerCase() > -1)) {
            this.selectedSupplier = supplier;
          }
        });
      }

    });
  }


  changeBackendPagination(page: number, size, csvExport?: boolean) {

    if (!csvExport) {
      csvExport = false;
    }
    $(".overlay-loading").show();
    this.page = page;
    if (this.page > 0) { }
    this.size = size;
    this.clearCache = false;


    const from_date = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
    const to_date = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);


    let formatted_from_date = this.datePipe.transform(from_date, 'yyyy-MM-dd 00:00:00');
    let formatted_to_date = this.datePipe.transform(to_date, 'yyyy-MM-dd 00:00:00');

    let requestUrl = null;
    if (!this.role || this.role != "ROLE_FTP_IMPORT") {
      let url = 'get-bol-details/v2?size=' + this.size + '&page=' + (this.page ? (this.page - 1) : 0);

      requestUrl = this.service.getBillOfladdings(
        url, formatted_from_date, formatted_to_date,
        this.filterQuery, this.orderNoFilter, this.carrierFilter,
        this.terminalFilter,
        this.supplierFilter,
        this.dealerFilter,
        this.bolStatusFilter,
        this.notesFilter,
        false,
        null,
        this.sortingModels,
        this.tacFilter,
        this.invoiceFilter,
        null,
        this.billtypeFilter
      );
    } else {

      requestUrl = this.service.getFTPRelatedBillofladings(this.size,
        this.page - 1,
        formatted_from_date,
        formatted_to_date,
        this.carrierFilter,
        this.supplierFilter,
        this.terminalFilter,
        this.bolStatusFilter,
        this.clearCache,
        this.notesFilter,
        this.orderNoFilter,
        false,
        this.dealerFilter,
        this.filterQuery,
        this.sortingModels,
        this.billtypeFilter
      );
    }

    // $(".overlay-loading").show();
    requestUrl.subscribe(data => {
      $(".overlay-loading").hide();
      if (csvExport) {
        var mediaType = "text/csv";
        var blob = new Blob([data], { type: mediaType });
        var filename = 'BOL-' + formatted_from_date.substr(0, 10) + '-' + formatted_to_date.substr(0, 10) + '.csv';
        importedSaveAs(blob, filename);
      } else {

        this.billOfLaddingResponse = data;
        this.allPageTotals = data.totalQuantity;
        this.totalRegQuantity = data.totalRegQuantity;
        this.totalMidQuantity = data.totalMidQuantity;
        this.totalSupQuantity = data.totalSupQuantity;
        this.totalUlsdQuantity = data.totalUlsdQuantity;
        this.totalOthQuantity = data.totalOthQuantity;
      }
      this.fetchDownloadableFiles()

    }, error => {
      console.log(error);
      this.billOfLaddingResponse = [];
      this.allPageTotals = 0;
      this.totalRegQuantity = 0;
      this.totalMidQuantity = 0;
      this.totalSupQuantity = 0;
      this.totalUlsdQuantity = 0;
      this.totalOthQuantity = 0;
      $(".overlay-loading").hide();
    });

    // this.httpRequest.subscribe(data => {
    //   this.billOfLaddingResponse = data;

    //   this.formatBilloflading(this.billOfLaddingResponse);
    //   this.filterLineItems(this.billOfLaddingResponse);
    //   this.totalRegQuantity = data.totalRegQuantity;
    //   this.totalMidQuantity = data.totalMidQuantity;
    //   this.totalSupQuantity = data.totalSupQuantity;
    //   this.totalUlsdQuantity = data.totalUlsdQuantity;
    //   this.totalOthQuantity = data.totalOthQuantity;



    //   // $(".overlay-loading").hide();
    // }, error => {
    //   console.error(error);
    // });
  }

  changeBackendSearch(page: number, size, csvExport?: boolean) {

    if (!csvExport) {
      csvExport = false;
    }
    $(".overlay-loading").show();
    this.page = page;
    if (this.page > 0) { }
    this.size = size;
    this.clearCache = false;

    const from_date = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day - 5);
    const to_date = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);

    let formatted_from_date = this.datePipe.transform(from_date, 'yyyy-MM-dd 00:00:00');
    let formatted_to_date = this.datePipe.transform(to_date, 'yyyy-MM-dd 00:00:00');

    let requestUrl = null;

    if (!this.role || this.role != "ROLE_FTP_IMPORT") {
      let url = 'get-bol-details/v2?size=5000' + '&page=' + (this.page ? (this.page - 1) : 0);
      requestUrl = this.service.getBillOfladdings(
        url, formatted_from_date, formatted_to_date,
        this.filterQuery, this.orderNoFilter, this.carrierFilter,
        this.terminalFilter,
        this.supplierFilter,
        this.dealerFilter,
        this.bolStatusFilter,
        this.notesFilter,
        false,
        null,
        this.sortingModels,
        this.tacFilter,
        this.invoiceFilter
      );
    } else {

      requestUrl = this.service.getFTPRelatedBillofladings(this.size,
        this.page - 1,
        formatted_from_date,
        formatted_to_date,
        this.carrierFilter,
        this.supplierFilter,
        this.terminalFilter,
        this.bolStatusFilter,
        this.clearCache,
        this.notesFilter,
        this.orderNoFilter,
        false,
        this.dealerFilter,
        this.filterQuery,
        this.sortingModels
      );
    }

    // $(".overlay-loading").show();
    requestUrl.subscribe(data => {
      if (csvExport) {
        var mediaType = "text/csv";
        var blob = new Blob([data], { type: mediaType });
        var filename = 'BOL-' + formatted_from_date.substr(0, 10) + '-' + formatted_to_date.substr(0, 10) + '.csv';
        importedSaveAs(blob, filename);
      } else {
        this.billOfLaddingResponse = data;
        this.allPageTotals = data.totalQuantity;
        this.totalRegQuantity = data.totalRegQuantity;
        this.totalMidQuantity = data.totalMidQuantity;
        this.totalSupQuantity = data.totalSupQuantity;
        this.totalUlsdQuantity = data.totalUlsdQuantity;
        this.totalOthQuantity = data.totalOthQuantity;
      }
      $(".overlay-loading").hide();
    });

  }

  public generateBackendFilters() {
    this.allowedTenants = [];
    /** Finding out all the tenants that are allowed for the particular customer.*/

    const whoOwnsItRequest = this.service.getUserWhoOwnsItDetails();
    whoOwnsItRequest.subscribe(data => {
      this.whoOwnsItsData.whoOwnsIts = data;

      const tenantRequest = this.service.getTenants();
      tenantRequest.subscribe(data => {
        this.whoOwnsItsData.tenantBilltypesMappings = data;

        // if (this.whoOwnsItsData.tenantBilltypesMapping.tenant.scac == this.user.scac) {
        //   this.allowedCustomers = 
        // }

        if (this.whoOwnsItsData.whoOwnsIts) {

          this.whoOwnsItsData.whoOwnsIts.forEach(whoOwnsIt => {
            this.whoOwnsItsData.tenantBilltypesMappings.forEach(tenantBilltypesMapping => {
              if (tenantBilltypesMapping.tenant.tenantId == whoOwnsIt.wholesalerTenantID) {
                if (this.allowedTenants.indexOf(tenantBilltypesMapping.tenant) == -1) {
                  this.allowedTenants.push(tenantBilltypesMapping.tenant);
                }
              }


            });
          });
        }
      });
    });



    // const usersRequest = this.service.getUsersForFtp();
    // usersRequest.subscribe(data => {
    //   this.whoOwnsItsData.users = data;
    // });


    if (!this.terminals || this.terminals.length <= 0) {
      this.fetchTerminalFilters(false);
    }

    if (!this.suppliers || this.suppliers.length <= 0) {
      this.fetchSupplierFilters(false);
    }

    if (!this.allowedCustomers || this.allowedCustomers.length <= 0) {
      this.fetchBilltypes(false);
    }


  }

  private fetchBilltypes(dismissFilter) {
    const billTypesRequest = this.service.getBilltypes();
    billTypesRequest.subscribe(billTypes => {
      console.log("Billtypes fetched ", billTypes);
      this.allowedCustomers = billTypes;
      if (dismissFilter) {
        $(".overlay-loading").hide();
      }
    })
  }

  private fetchDealerFilters(dismissFilter) {
    const dealerRequest = this.service.getDealers();
    dealerRequest.subscribe(data => {
      this.whoOwnsItsData.dealers = data;
      this.dealers = data;
      if (dismissFilter) {
        $(".overlay-loading").hide();
      }
    });
  }

  displayCount() {
    console.log(this.dealers.length);
    console.log(this.dealers[0]);
  }

  private fetchSupplierFilters(dismissFilter) {
    const supplierRequest = this.service.getSuppliers();
    supplierRequest.subscribe(data => {
      this.whoOwnsItsData.suppliers = data;
      this.suppliers = data;
      this.rearrangeSupplierFilters();
      if (dismissFilter) {
        $(".overlay-loading").hide();
      }
    });
  }

  private fetchTerminalFilters(dismissFilter) {
    const terminalRequest = this.service.getTerminals();
    terminalRequest.subscribe(data => {
      this.whoOwnsItsData.terminals = data;
      this.terminals = data;
      this.rearrangeTerminalFilters();
      if (dismissFilter) {
        $(".overlay-loading").hide();
      }
    });
  }

  checkTerminalFiltersAvailability() {
    if (!this.terminals || this.terminals.length <= 0) {
      $(".overlay-loading").show();
      this.fetchTerminalFilters(true);
    }
  }

  checkSupplierFiltersAvailability() {
    if (!this.suppliers || this.suppliers.length <= 0) {
      $(".overlay-loading").show();
      this.fetchSupplierFilters(true);
    }
  }

  checkDealerFiltersAvailability() {
    if (!this.dealers || this.dealers.length <= 0) {
      $(".overlay-loading").show();
      this.fetchDealerFilters(true);
    }
  }

  checkBilltypeFiltersAvailability() {
    if (!this.allowedCustomers || this.allowedCustomers.length <= 0) {
      $(".overlay-loading").show();
      this.fetchBilltypes(true);
    }
  }

  public rearrangeTerminalFilters() {
    this.terminals.forEach(terminal => {
      for (let allowedTenant of this.allowedTenants) {
        if (terminal.tenant == allowedTenant.tenantId) {
          terminal.tenantName = allowedTenant.scac;
          break;
        }
      }
    })
    let filteredTerminals = [];
    this.terminals.forEach(terminal => {
      var matchFound = false;
      for (let addedTerminal of filteredTerminals) {
        if (terminal.terminalName && addedTerminal.terminalName &&
          terminal?.terminalName?.toLowerCase() == addedTerminal?.terminalName?.toLowerCase()) {
          matchFound = true;
          break;
        }
      }
      if (!matchFound) {
        filteredTerminals.push(terminal);
      }
    })

    this.terminals = filteredTerminals;

    this.suppliers.forEach(supplier => {
      for (let allowedTenant of this.allowedTenants) {
        if (supplier.tenant == allowedTenant.tenantId) {
          supplier.tenantName = allowedTenant.scac;
          break;
        }
      }
    })
  }


  public rearrangeSupplierFilters() {
    let filteredSuppliers = [];
    this.suppliers.forEach(supplier => {
      var matchFound = false;
      for (let addedSupplier of filteredSuppliers) {
        if (supplier.loadUnderName && addedSupplier && addedSupplier.loadUnderName &&
          supplier.loadUnderName.toLowerCase() == addedSupplier.loadUnderName.toLowerCase()) {
          matchFound = true;
          break;
        }
      }
      if (!matchFound) {
        filteredSuppliers.push(supplier);
      }

      $(".overlay-loading").hide();
    })

    this.suppliers = filteredSuppliers;
  }

  filterLineItems(billofladings) {
    let changedBol = [];
    let index = 0;
    for (let bol of billofladings) {
      changedBol.push(bol);
      if (true) {
        let singleBolDetail = [];
        let retainedBolDetails = [];
        let detailsCounter = 0;
        let total, reg, mid, sup, ulsd, oth;
        total = reg = mid = sup = ulsd = oth = 0;
        for (let bolDetail of bol.billofladingdetails) {
          //Only add the first item if the load is not a multiterminal and multisupplier load.
          if (!bol.twoTerminalLoad && !bol.multipleSuppliers) {
            if (detailsCounter == 0) {
              singleBolDetail.push(bolDetail);
            }
            retainedBolDetails.push(bolDetail);
          }

          else {
            retainedBolDetails.push(bolDetail);
          }
          if (bolDetail.product.productId == 1 || bolDetail.product.displayCode == 'REG') reg += bolDetail.quantity;
          if (bolDetail.product.productId == 2 || bolDetail.product.displayCode == 'MID') mid += bolDetail.quantity;
          if (bolDetail.product.productId == 3 || bolDetail.product.displayCode == 'SUP') sup += bolDetail.quantity;
          if (bolDetail.product.productId == 4 || bolDetail.product.displayCode == 'ULSD') ulsd += bolDetail.quantity;
          if (bolDetail.product.productId > 4 || bolDetail.product.productId < 1) oth += bolDetail.quantity;
          detailsCounter++;
        }

        //If there are loads that need to be grouped together and the load is not a multi terminal or multi supplier load.
        if (singleBolDetail.length > 0 && !bol.twoTerminalLoad && !bol.multipleSuppliers) {
          singleBolDetail[0].reg = reg;
          singleBolDetail[0].mid = mid;
          singleBolDetail[0].sup = sup;
          singleBolDetail[0].ulsd = ulsd;
          singleBolDetail[0].oth = oth;

          changedBol[index].billofladingdetails = singleBolDetail;
          changedBol[index].retainedBillofladingdetails = retainedBolDetails;
        }
        //else Add the loads to the retained billofladingdetails.
        else {
          changedBol[index].retainedBillofladingdetails = retainedBolDetails;
        }

      }

      index++;
    }
  }

  formatBilloflading(data: any[]) {

  }


  public changeTerminalFilter(terminal): void {
    if (terminal) {
      this.terminalFilter = terminal ? terminal.terminalId : null;
      this.terminalFilter += ':' + terminal.tenant;
    }
    else {
      this.terminalFilter = null;
    }
  }

  public changeSupplierFilter(supplier): void {
    if (supplier) {
      this.supplierFilter = supplier ? supplier.loadUnderID : null;
      this.supplierFilter += ':' + supplier.tenant;
    }
    else {
      this.supplierFilter = null;
    }
  }

  /**
   * Dealer Filter changes...
   * @param dealer 
   */
  public changeDealerFilter(): void {

    let dealer = this.selectedDealer;
    if (dealer) {
      this.dealerFilter = dealer ? dealer.locationID : null;
      this.dealerFilter += ':' + dealer.tenant;
    }
    else {
      this.dealerFilter = null;
    }
    if (this.dealerFilter) {
      this.changeBackendPagination(0, this.noOfRecord);
    }
  }


  private formatDate() {
    var d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
  //get-bol-details?size=20&page=0&sort-by=tStamp,tenant,billOfLadingId&order-by=desc,desc,asc'

  formatDateForDisplay(date) {
    return this.ngbCustomDateParserService.format(date);
  }

  public converToArray(billOfladdinDetails: any, parentIndex: number): any[] {
    let temp: any[] = [];
    billOfladdinDetails = billOfladdinDetails ? billOfladdinDetails : {};
    billOfladdinDetails['reg'] = 0;
    billOfladdinDetails['mid'] = 0;
    billOfladdinDetails['sup'] = 0;
    billOfladdinDetails['ulsd'] = 0;
    billOfladdinDetails['oth'] = 0;
    for (let bolDetail of this.billOfLaddingResponse.billofladings[parentIndex].billofladingdetails) {

      if (bolDetail?.product?.productId == 1 || bolDetail?.product?.displayCode == 'REG') billOfladdinDetails['reg'] += bolDetail?.quantity;
      if (bolDetail?.product?.productId == 2 || bolDetail?.product?.displayCode == 'MID') billOfladdinDetails['mid'] += bolDetail?.quantity;
      if (bolDetail?.product?.productId == 3 || bolDetail?.product?.displayCode == 'SUP') billOfladdinDetails['sup'] += bolDetail?.quantity;
      if (bolDetail?.product?.productId == 4 || bolDetail?.product?.displayCode == 'ULSD') billOfladdinDetails['ulsd'] += bolDetail?.quantity;
      if (bolDetail?.product?.productId > 4 || bolDetail?.product?.productId < 1) billOfladdinDetails['oth'] += bolDetail?.quantity;
    }


    temp.push(billOfladdinDetails);

    return temp;
  }




  public resetFilter(today?): void {
    this.filterQuery = null;
    this.orderNoFilter = null;
    this.carrierFilter = null;
    this.terminalFilter = null;
    this.supplierFilter = null;
    this.dealerFilter = null;
    this.bolStatusFilter = null;
    this.notesFilter = null;
    this.tacFilter = null;
    this.invoiceFilter = null;
    this.billtypeFilter = null;
    this.noOfRecord = 50;

    this.billOfLaddingResponse = null;

    this.selectedDealer = null;
    this.selectedSupplier = null;
    this.selectedTerminal = null;
    if (!today) {
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 1);
    } else {
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 0);
    }
    this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 0);

    this.getBillOfLaddings(false);
  }

  public openModalForDetails(content?: any, item?: any): void {
    this.selectedItem = item;
    this.bolImages = [];
    console.log("Selected Item", this.selectedItem);
    this.calculateTimeDifferences();

    this.selectedRouteSheet = {};

    this.service.getRouteForBol(this.selectedItem?.billOfLadingId, this.selectedItem?.tenant).subscribe(route => {
      console.log("Route fetched", route);
      this.selectedRouteSheet = route;
    });

    this.service.getImagesForBol("uploads/" + this.selectedItem?.billOfLadingId, this.selectedItem?.tenant).subscribe(images => {
      console.log("Images fetched", images);
      this.bolImages = images;
    });

    this.modalRef = this.ngModal.open(content, {
      size: "lg"
    });

    this.fetchDealerNotes(this.selectedItem?.billOfLadingId, this.selectedItem?.tenant);

  }

  public downloadPdf(pdf) {
    saveAs(pdf, "download.pdf");
  }

  private calculateTimeDifferences() {
    let atRackTime, leftRackTime, atLocationTime, leftLocationTime;

    if (this.selectedItem.arrivedAtRackTime && this.selectedItem.leftRackTime) {
      atRackTime = new Date(this.selectedItem.arrivedAtRackTime);
      leftRackTime = new Date(this.selectedItem.leftRackTime);
      this.selectedItem.rackTimeDiff = (leftRackTime - atRackTime) / (1000 * 60);
    }

    if (this.selectedItem.arrivedAtCustomerTime && this.selectedItem.finalizedDeliveryTime) {
      atLocationTime = new Date(this.selectedItem.arrivedAtCustomerTime);
      leftLocationTime = new Date(this.selectedItem.finalizedDeliveryTime);
      this.selectedItem.locationTimeDiff = (leftLocationTime - atLocationTime) / (1000 * 60);
    }
  }

  closeDatePicker = false;
  onDateSelection(date: NgbDate) {
    this.closeDatePicker = false;
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
      this.closeDatePicker = true;
      this.showOverlay = false;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate, input: string): NgbDate {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  insertSortingObject(fieldName) {

    var sortingModel: SortingModel = new SortingModel();
    sortingModel.fieldName = fieldName;

    this.checkAndChangeSortingStatus(fieldName);

    var matchFound = false;
    var index: number = 0;
    for (let individualSortingModel of this.sortingModels) {
      if (individualSortingModel.equals(sortingModel)) {
        matchFound = true;
        break;
      }
      index++;
    }

    if (!matchFound) {
      this.sortingModels.push(sortingModel);
      this.sortingModels[this.sortingModels.length - 1].changeStatus();
    } else {
      var changeStatus: boolean = this.sortingModels[index].changeStatus();
      if (!changeStatus) {
        this.sortingModels.splice(index, 1);
      }
    }
    this.getBillOfLaddingsWithSorting()

  }


  private checkAndChangeSortingStatus(fieldName: any) {
    let currentStatusValue = "", currentStatusFieldName = "";
    if (fieldName == "billofladingid") {
      var idStatus = this.sortingCurrentStatus.idStatus;
      this.sortingCurrentStatus.idStatus = idStatus == 'asc' ? 'desc' : idStatus == 'desc' ? 'NA' : idStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.idStatus;
      currentStatusFieldName = "idStatus";
    }
    if (fieldName == "orderno") {
      var orderNoStatus = this.sortingCurrentStatus.orderNoStatus;
      this.sortingCurrentStatus.orderNoStatus = orderNoStatus == 'asc' ? 'desc' : orderNoStatus == 'desc' ? 'NA' : orderNoStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.orderNoStatus;
      currentStatusFieldName = "orderNoStatus";
    }
    if (fieldName == "tenant") {
      var tenantStatus = this.sortingCurrentStatus.tenantStatus;
      this.sortingCurrentStatus.tenantStatus = tenantStatus == 'asc' ? 'desc' : tenantStatus == 'desc' ? 'NA' : tenantStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.tenantStatus;
      currentStatusFieldName = "tenantStatus";
    }
    if (fieldName == "station") {
      var stationStatus = this.sortingCurrentStatus.stationStatus;
      this.sortingCurrentStatus.stationStatus = stationStatus == 'asc' ? 'desc' : stationStatus == 'desc' ? 'NA' : stationStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.stationStatus;
      currentStatusFieldName = "stationStatus";
    }
    if (fieldName == "city") {
      var cityStatus = this.sortingCurrentStatus.cityStatus;
      this.sortingCurrentStatus.cityStatus = cityStatus == 'asc' ? 'desc' : cityStatus == 'desc' ? 'NA' : cityStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.cityStatus;
      currentStatusFieldName = "cityStatus";
    }
    if (fieldName == "terminal") {
      var terminalStatus = this.sortingCurrentStatus.terminalStatus;
      this.sortingCurrentStatus.terminalStatus = terminalStatus == 'asc' ? 'desc' : terminalStatus == 'desc' ? 'NA' : terminalStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.terminalStatus;
      currentStatusFieldName = "terminalStatus";
    }
    if (fieldName == "supplier") {
      var supplierStatus = this.sortingCurrentStatus.supplierStatus;
      this.sortingCurrentStatus.supplierStatus = supplierStatus == 'asc' ? 'desc' : supplierStatus == 'desc' ? 'NA' : supplierStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.supplierStatus;
      currentStatusFieldName = "supplierStatus";
    }
    if (fieldName == "status") {
      var statusStatus = this.sortingCurrentStatus.statusStatus;
      this.sortingCurrentStatus.statusStatus = statusStatus == 'asc' ? 'desc' : statusStatus == 'desc' ? 'NA' : statusStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.statusStatus;
      currentStatusFieldName = "statusStatus";
    }
    if (fieldName == "scheduleDate") {
      var dateStatus = this.sortingCurrentStatus.dateStatus;
      this.sortingCurrentStatus.dateStatus = dateStatus == 'asc' ? 'desc' : dateStatus == 'desc' ? 'NA' : dateStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.dateStatus;
      currentStatusFieldName = "dateStatus";
    }
    if (fieldName == "eta") {
      var etaStatus = this.sortingCurrentStatus.etaStatus;
      this.sortingCurrentStatus.etaStatus = etaStatus == 'asc' ? 'desc' : etaStatus == 'desc' ? 'NA' : etaStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.etaStatus;
      currentStatusFieldName = "etaStatus";
    }
    if (fieldName == "tac") {
      var tacStatus = this.sortingCurrentStatus.tacStatus;
      this.sortingCurrentStatus.tacStatus = tacStatus == 'asc' ? 'desc' : tacStatus == 'desc' ? 'NA' : tacStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.tacStatus;
      currentStatusFieldName = "tacStatus";
    }
    if (fieldName == "invoice") {
      var invoiceStatus = this.sortingCurrentStatus.invoiceStatus;
      this.sortingCurrentStatus.invoiceStatus = invoiceStatus == 'asc' ? 'desc' : invoiceStatus == 'desc' ? 'NA' : invoiceStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.invoiceStatus;
      currentStatusFieldName = "invoiceStatus";
    }
    if (fieldName == "billoflading") {
      var bolStatus = this.sortingCurrentStatus.bolStatus;
      this.sortingCurrentStatus.bolStatus = bolStatus == 'asc' ? 'desc' : bolStatus == 'desc' ? 'NA' : bolStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.bolStatus;
      currentStatusFieldName = "bolStatus";
    }
    if (fieldName == "total") {
      var totalStatus = this.sortingCurrentStatus.totalStatus;
      this.sortingCurrentStatus.totalStatus = totalStatus == 'asc' ? 'desc' : totalStatus == 'desc' ? 'NA' : totalStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.totalStatus;
      currentStatusFieldName = "totalStatus";
    }
    if (fieldName == "billtype") {
      var billtypeStatus = this.sortingCurrentStatus.billtypeStatus;
      this.sortingCurrentStatus.billtypeStatus = billtypeStatus == 'asc' ? 'desc' : billtypeStatus == 'desc' ? 'NA' : billtypeStatus == 'NA' ? 'asc' : '';
      currentStatusValue = this.sortingCurrentStatus.billtypeStatus;
      currentStatusFieldName = "billtypeStatus";
    }


    this.resetOthers(currentStatusFieldName, currentStatusValue);
  }

  private resetOthers(filterFlagName, filterValue) {

    this.sortingCurrentStatus = new SortingCurrentStatus();
    this.sortingCurrentStatus[filterFlagName] = filterValue;
    return this.sortingCurrentStatus;
  }

  private connectWebSocket(): void {
    let ref = this;
    let socket = new SockJs(environment.apiURL + 'secured/chat/location-verification?access_token=' + localStorage.getItem("access_token"));
    ref.stompClient = Stomp.over(socket);

    ref.stompClient.connect({}, (frame) => {
      // Subscribe and open modal once export is ready
      ref.stompClient.subscribe('/secured/history/filter-dealers/' + this.user.user.email + ":" + this.user.user.tenant.scac, (message) => {

        let dealers = JSON.parse(message.body);

        localStorage.setItem("mapComparisonObject", message.body);


      });
    });

  }

  gotoLite() {
    window.open('https://ceconnect.creative123.net', '_blank')
  }

  displayProductDetails(billofladingdetail) {
    alert('Hi');
    console.log(billofladingdetail);
  }

  checkSiteIdFilter() {

    if (this.tacFilter) {
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 30);
      this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 0);
    } else if (this.invoiceFilter) {
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 366);
      this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 0);
    } else {
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 1);
      this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 0);
    }
  }

  openEditModal(content, item) {
    this.selectedItem = item;
    this.bolImages = [];
    console.log("Selected Item", this.selectedItem);
    this.calculateTimeDifferences();

    this.selectedRouteSheet = {};

    this.service.getRouteForBol(this.selectedItem?.billOfLadingId, this.selectedItem?.tenant).subscribe(route => {
      console.log("Route fetched", route);
      this.selectedRouteSheet = route;
    });

    this.service.getImagesForBol("uploads/" + this.selectedItem?.billOfLadingId, this.selectedItem?.tenant).subscribe(images => {
      console.log("Images fetched", images);
      this.bolImages = images;
    });

    this.modalRef = this.ngModal.open(content, {
      size: "lg"
    });
  }

  saveLoad() {
    if (this.user?.user?.role?.role == "ROLE_FTP_IMPORT") {
      this.saveCsvLoad();
    } else if (this.user?.user?.role?.role == "ROLE_DRIVER_ADMIN") {
      this.saveTDLoad();
    }
  }

  saveCsvLoad() {
    console.log("Selected Item for CSV", this.selectedItem);
    $(".overlay-loading").show();
    this.selectedItem.arrivedAtRackTime = this.getDateFromTIme(this.selectedItem.arrivedAtRackTimeTemp);
    this.selectedItem.leftRackTime = this.getDateFromTIme(this.selectedItem.leftRackTimeTemp);
    this.selectedItem.arrivedAtCustomerTime = this.getDateFromTIme(this.selectedItem.arrivedAtCustomerTimeTemp);
    this.selectedItem.finalizedDeliveryTime = this.getDateFromTIme(this.selectedItem.finalizedDeliveryTimeTemp);

    let load = {
      "salesOrderNumber": this.selectedItem?.billOfLadingId + "",
      "customerNo": this.selectedItem?.billingCode + "",
      "atRack": this.selectedItem.arrivedAtRackTime,
      "leftRack": this.selectedItem.leftRackTime,
      "atLocationTime": this.selectedItem.arrivedAtCustomerTime,
      "leftLocationTime": this.selectedItem.finalizedDeliveryTime,
      "quantityOrdered": this.selectedItem?.billofladingdetails[0]?.quantity ? this.selectedItem?.billofladingdetails[0]?.quantity + "" : "",
      "netGallons": this.selectedItem?.billofladingdetails[0]?.netGallons ? this.selectedItem?.billofladingdetails[0]?.netGallons + "" : null,
      "loadingBol": this.selectedItem?.billofladingdetails[0]?.billofLadingSub ? this.selectedItem?.billofladingdetails[0]?.billofLadingSub + "" : null
    };
    this.userService.saveLoadDetailsMultiple(load).subscribe(response => {
      $(".overlay-loading").hide();
      console.log("response ", response);
      this.getBillOfLaddings(false);
    }, error => {
      $(".overlay-loading").hide();
      console.error(error);
    })
  }

  saveTDLoad() {
    console.log("Selected Item for TD", this.selectedItem);
    $(".overlay-loading").show();
    this.selectedItem.arrivedAtRackTime = this.getDateFromTIme(this.selectedItem.arrivedAtRackTimeTemp);
    this.selectedItem.leftRackTime = this.getDateFromTIme(this.selectedItem.leftRackTimeTemp);
    this.selectedItem.arrivedAtCustomerTime = this.getDateFromTIme(this.selectedItem.arrivedAtCustomerTimeTemp);
    this.selectedItem.finalizedDeliveryTime = this.getDateFromTIme(this.selectedItem.finalizedDeliveryTimeTemp);
    if (this.billofladingNotes) {
      this.selectedItem.billofladingNotes = this.selectedItem.billofladingNotes ? this.selectedItem.billofladingNotes : [];
      this.selectedItem.billofladingNotes.push(this.billofladingNotes);
    }
    this.userService.saveLoadDetailsTD(this.selectedItem).subscribe(response => {
      $(".overlay-loading").hide();
      console.log("response ", response);
      this.saveBolNote(this.selectedItem?.billOfLadingId, this.selectedItem?.tenant, this.selectedItem?.billofladingNotes);
      this.getBillOfLaddings(false);
    }, error => {
      $(".overlay-loading").hide();
      console.error(error);
    })
  }

  getDateFromTIme(time) {
    if (time) {
      let convertedTime = this.datePipe.transform(new Date(), "yyyy-MM-dd");

      if (time?.includes('AM')) {
        convertedTime += " " + time.replace(" AM", "") + ":00";
        convertedTime = this.datePipe.transform(convertedTime, 'yyyy-MM-dd HH:mm:ss');
      } else if (time?.includes('PM')) {
        convertedTime += " " + time.replace(" PM", "") + ":00";
        convertedTime = this.datePipe.transform(convertedTime, 'yyyy-MM-dd HH:mm:ss');
        convertedTime = this.addHours(new Date(convertedTime), 12);
      }
      console.log("Converted TIme", convertedTime);
      return convertedTime;
    }
  }

  addHours(date, hours) {
    date.setHours(date.getHours() + hours);
    return this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
  }

  convertTime(time, tempTime) {

    if (this.dateValidation(time) && !this.selectedItem[tempTime]) {
      try {
        let convertedTime = this.datePipe.transform(time, 'hh:mm aa')
        console.log("Converted TIme", convertedTime);
        this.selectedItem[tempTime] = convertedTime;
      } catch (e) {

      }
    }
  }

  dateValidation(d) {
    return !!new Date(d).getTime();
  }

  checkBatchNumberAvailability(item) {
    if (item?.batchNumber && item?.batchNumber != 0 && this.availableBatchNumbers) {
      for (let batchNumber of this.availableBatchNumbers) {
        if (batchNumber.includes(item?.batchNumber)) {
          return true;
        }
      }
    }
    return false;
    // return item?.batchNumber && item?.batchNumber != 0 && this.availableBatchNumbers.includes("Invoices/"+item?.batchNumber+".pdf");
  }

  checkBolImageSentAvailability(item) {
    if (item?.bolimageSent && item?.bolimageSent != 0 && this.availableBolImageSent) {
      for (let bolimageSent of this.availableBolImageSent) {
        if (bolimageSent.includes(item?.billOfLadingId)) {
          return true;
        }
      }
    }
    return false;
    // return item?.batchNumber && item?.batchNumber != 0 && this.availableBatchNumbers.includes("Invoices/"+item?.batchNumber+".pdf");
  }

  // checkBolImageSentAvailability(item){
  //   return item?.bolimageSent && item?.bolimageSent != 0 && this.availableBolImageSent.includes("Invoices/"+item?.billOfLadingId+".pdf");
  // }

  shouldShowCarrierSelection(user) {
    return user?.user?.role?.role != 'ROLE_TENANT_ADMIN' && user?.user?.role?.role != 'ROLE_DRIVER_ADMIN'
  }

  checkEditOption(user) {
    return (user?.user?.role?.role == 'ROLE_FTP_IMPORT' && this.allowBolEditFromPortal) || (user?.user?.role?.role == 'ROLE_DRIVER_ADMIN' && this.allowBolEditFromPortal)
  }

  fetchDealerNotes(billOfLadingId, tenant) {
    this.userService.fetchDealerNotes(billOfLadingId, tenant).subscribe((data: any) => {
      this.selectedItem.billofladingNotes = data?.driverNotes;
      this.billofladingidHub = data?.billofladingidHub;
    })
  }

  saveBolNote(billOfLadingId, tenant, driverNotes) {
    let load = {
      "billOfLadingID": billOfLadingId,
      "tenant": tenant,
      "driverNotes": driverNotes,
      "billofladingidHub": this.billofladingidHub ? this.billofladingidHub : null
    };
    $(".overlay-loading").show();
    this.userService.saveBolNote(load).subscribe(response => {
      $(".overlay-loading").hide();
      console.log("response ", response);
    }, error => {
      $(".overlay-loading").hide();
      console.error(error);
    })
  }

  // CDN URLs for browser builds
  JSZIP_CDN = 'https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js';
  FILESAVER_CDN = 'https://cdn.jsdelivr.net/npm/file-saver@2.0.5/dist/FileSaver.min.js';

  loadScriptOnce(url): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      // If already loaded (by exact src), resolve immediately
      const existing = Array.from(document.getElementsByTagName('script'))
        .find(s => s.src && s.src.indexOf(url) !== -1);
      if (existing) {
        if (typeof existing.onload === 'function') {
          // assume it's loaded or loading
          existing.addEventListener('load', () => resolve());
          existing.addEventListener('error', () => reject(new Error('Failed to load ' + url)));
        } else {
          resolve();
        }
        return;
      }

      const s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('Failed to load ' + url));
      document.head.appendChild(s);
    });
  }

  // Utility: safe filename from URL
  getFileNameFromUrl(url, idx) {
    try {
      const name = url.split('/').filter(Boolean).pop();
      return name || `file_${idx}`;
    } catch {
      return `file_${idx}`;
    }
  }

  onBolImageSelect(image, selected: boolean) {
    console.log("Image selected", image, selected);
    if (selected) {
      this.selectedBolImagesList.push(image);
    } else {
      const index = this.selectedBolImagesList.indexOf(image);
      if (index > -1) {
        this.selectedBolImagesList.splice(index, 1);
      }
    }
  }

  onBolImageSelectFromGrid(bolId, selected: boolean) {
      const idStr = String(bolId).toLowerCase();
      const matches = (this.bolImagesList || []).filter(entry =>
        entry && typeof entry.key === 'string' && entry.key.toLowerCase().includes(idStr)
      );

      if (selected) {
        for (const m of matches) {
          const exists = (this.selectedBolImagesList || []).some(e => e && e.key === m.key && e.value === m.value);
          if (!exists) {
            this.selectedBolImagesList.push(m);
          }
        }
      } else {
        if (!this.selectedBolImagesList || this.selectedBolImagesList.length === 0) {
          return;
        }
        for (const m of matches) {
          this.selectedBolImagesList = this.selectedBolImagesList.filter(e => !(e && e.key === m.key && e.value === m.value));
        }
      }
  }

  hasImage(item) {
    const idStr = String(item).toLowerCase();
    const list = Array.isArray(this.selectedBolImagesList) ? this.selectedBolImagesList : [];

    for (const entry of list) {
      let key = '';
      if (typeof entry === 'string') {
        key = entry;
      } else if (entry && typeof entry.key === 'string') {
        key = entry.key;
      } else if (entry && typeof entry.value === 'string') {
        key = entry.value;
      }
      if (key.toLowerCase().includes(idStr)) {
        return true;
      }
    }

    return false;

  }

  onInvoiceSelect(invoice, selected: boolean) {
    if (selected) {
      this.selectedInvoicesList.push(invoice);
    } else {
      const index = this.selectedInvoicesList.indexOf(invoice);
      if (index > -1) {
        this.selectedInvoicesList.splice(index, 1);
      }
    }
  }

}

// ts-fflate-zip.ts
// No npm required — loads fflate UMD from CDN at runtime and zips given URLs.
// Usage: await onDownloadClick(['https://.../a.jpg', 'https://.../b.pdf'], 'myfiles.zip');

// --- adjust CDN if you want a different version ---
const FFLATE_CDN = 'https://cdn.jsdelivr.net/npm/fflate/umd/index.js';

// Declare the global window.fflate shape we need (minimal)
declare global {
  interface Window {
    fflate?: {
      zipSync: (files: Record<string, Uint8Array>) => Uint8Array;
    };
  }
}

/**
 * Dynamically load a script only once.
 */
function loadScriptOnce(url: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    // already present?
    const existing = Array.from(document.getElementsByTagName('script'))
      .find(s => s.src && s.src.indexOf(url) !== -1);
    if (existing) {
      // if already loaded, resolve when load fires (or immediately if already loaded)
      if ((existing as HTMLScriptElement).getAttribute('data-loaded') === '1') {
        return resolve();
      }
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () => reject(new Error('Failed to load ' + url)));
      return;
    }

    const s = document.createElement('script');
    s.src = url;
    s.async = true;
    s.onload = () => { s.setAttribute('data-loaded', '1'); resolve(); };
    s.onerror = () => reject(new Error('Failed to load ' + url));
    document.head.appendChild(s);
  });
}

/** Safe filename extractor */
function getFileNameFromUrl(url: string, idx: number): string {
  try {
    const parts = url.split('/').filter(Boolean);
    const last = parts.pop();
    return last && last.length > 0 ? last : `file_${idx}`;
  } catch {
    return `file_${idx}`;
  }
}

/**
 * Main function to call on button click.
 * Sequential downloads (gentler on memory). If you want concurrency, change logic.
 */
export async function onDownloadClick(urls, zipFileName: string = 'files.zip'): Promise<void> {
  if (!urls || !Array.isArray(urls) || urls.length === 0) {
    console.warn('No URLs provided.');
    return;
  }

  // Load fflate UMD if needed
  try {
    if (typeof window.fflate === 'undefined') {
      await loadScriptOnce(FFLATE_CDN);
    }
    if (typeof window.fflate === 'undefined' || typeof window.fflate.zipSync !== 'function') {
      throw new Error('fflate failed to load or did not expose expected API on window.fflate');
    }
  } catch (err) {
    console.error('Failed to load fflate library:', err);
    // In an Angular app you might show a toast rather than alert
    alert('Could not load zip library. Check console for details.');
    return;
  }

  const { zipSync } = window.fflate!;
  const filesForZip: Record<string, Uint8Array> = {};
  const errors: Array<{ url: string; error: string }> = [];

  // Sequential fetch
  for (let i = 0; i < urls.length; i++) {
    const url = urls[i].key;
    const name = urls[i].value.replace("Invoices/", "").replace("Images/", "").split('::')[0] || `file_${i}`;
    try {
      // If you need cookies or auth tokens, change fetch options:
      // fetch(url, { credentials: 'include', headers: { Authorization: 'Bearer ...' }})
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status} ${res.statusText}`);
      const ab = await res.arrayBuffer();
      filesForZip[name] = new Uint8Array(ab);
      // optional: update progress UI here
      console.log(`Fetched ${name} (${i + 1}/${urls.length})`);

      document.getElementById('percent').innerText = Math.round(((i + 1) / urls.length) * 100).toString()+"%";
      document.getElementById('percentBar').style.width = Math.round(((i + 1) / urls.length) * 100).toString()+"%";
      document.getElementById('download-text').innerText = `Downloading ${name}... (${i + 1} of ${urls.length})`;

    } catch (err: any) {
      console.error(`Failed to fetch ${url}:`, err);
      errors.push({ url, error: err?.message ?? String(err) });
      // add an error file so user knows which items failed
      const errName = `${name}.download-error.txt`;
      filesForZip[errName] = new TextEncoder().encode(`Failed to download ${url}\n\n${err?.stack ?? err}`);
    }
  }

  try {
    // compress to zip (returns Uint8Array)`
    const zipped: any = zipSync(filesForZip);
    const blob = new Blob([zipped], { type: 'application/zip' });

    // trigger download without FileSaver
    const link = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    link.href = objectUrl;
    link.download = zipFileName || 'files.zip';
    // Required for Firefox
    document.body.appendChild(link);
    link.click();
    // Cleanup
    setTimeout(() => {
      URL.revokeObjectURL(objectUrl);
      try { document.body.removeChild(link); } catch { /* ignore */ }
    }, 1000);

    console.log('ZIP download started:', zipFileName);
    if (errors.length) {
      console.warn('Completed with errors:', errors);
      // Show or log errors as needed in your UI
    }
  } catch (err) {
    console.error('Error creating ZIP:', err);
    alert('Failed to create ZIP. Check console for details.');
  }
}

